<template>
  <div class="modal skin-modal offer-details-modal">
    <div class="overlay" @click="close"></div>
    <div class="wrapper">
      <img class="close" @click="close" src="./../assets/close.svg" />
      <div class="container">
        <form @submit.prevent>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title title-24">
                <b>{{ $t('Offer details') }}</b>
              </div>
              <div class="form-fields-wrapper">
                <div class="offer-wrapper">
                  <div class="row">
                    <div class="label">{{ $t('Skin name') }}</div>
                    <div class="value">{{ orderToView.title }}</div>
                  </div>
                  <div class="row">
                    <div class="label">{{ $t('Quality') }}</div>
                    <div class="value">{{ orderToView.quality }}</div>
                  </div>
                  <div class="row">
                    <div class="label">{{ $t('Desired price') }}</div>
                    <div class="value">
                      <b>{{ orderToView.user_price }} {{ orderToView.currency }}</b>
                    </div>
                  </div>
                  <div class="row" v-if="orderToView.service_price">
                    <div class="label">{{ $t('Our price') }}</div>
                    <div class="value">
                      <b>{{ orderToView.service_price }} {{ orderToView.currency }}</b>
                    </div>
                  </div>

                  <transition name="slide">
                    <div v-if="error" class="error-desc desc red">
                      {{ error }}
                    </div>
                  </transition>

                  <div class="buttons-special" v-if="orderToView.status === 'offer'">
                    <button
                      type="button"
                      class="button back-btn"
                      @click="decline"
                      :disabled="isLoading"
                    >
                      <span>{{ isLoading ? $t('Processing...') : $t('Decline') }}</span>
                    </button>
                    <button
                      type="button"
                      class="button"
                      @click="accept"
                      :disabled="isLoading"
                    >
                      <span>{{ isLoading ? $t('Accepting...') : $t('Accept') }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfferDetailsModal',
  props: {
    orderToView: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: false,
      error: '',
    };
  },
  watch: {
    orderToView() {
      this.error = '';
      this.isLoading = false;
    },
  },
  methods: {
    handleApiCall(endpoint, successMessage) {
      if (this.isLoading) return;
      this.isLoading = true;
      this.error = '';

      const data = { id: this.orderToView.id };

      this.$http
        .post(process.env.VUE_APP_API + endpoint, data)
        .then(() => {
          console.log(successMessage);
          this.$emit('actionCompleted');
          this.close();
        })
        .catch((err) => {
          this.error =
            err.response?.data?.message || 'An unexpected error occurred.';
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    decline() {
      this.handleApiCall('offer/decline', 'Offer declined successfully.');
    },
    accept() {
      this.handleApiCall('offer/accept', 'Offer accepted successfully.');
    },
    close() {
      this.error = '';
      this.$emit('closeOfferDetailsModal');
    },
  },
};
</script>

<style scoped>
.offer-details-modal .offer-wrapper {
  margin-top: 24px;
}

.offer-details-modal .row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
}

.offer-details-modal .row:not(:last-child) {
  border-bottom: 1px solid #F0F2F3;
}

.offer-details-modal .row .label {
  font-size: 16px;
  line-height: 22px;
  color: #AAB0C5;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
}

.offer-details-modal .row .value {
  font-size: 16px;
  line-height: 22px;
  color: #363D47;
  font-family: 'Outfit', sans-serif;
  font-weight: 700;
  text-align: right;
}

.offer-details-modal .buttons-special {
  display: flex;
  gap: 16px;
  margin-top: 46px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.offer-details-modal .buttons-special .button {
  width: auto !important;
  flex-shrink: 0;
  flex-grow: 0;
}

.offer-details-modal .back-btn {
  background: transparent;
  border: 2px solid #363D47;
  color: #363D47;
  padding: 12px 42px;
  box-shadow: none;
}

.offer-details-modal .back-btn:hover {
  background: #363D47;
  color: #fff;
  opacity: 1;
}

.offer-details-modal .back-btn.disabled {
  background: transparent;
  border: 2px solid #D6DAEA;
  color: #D6DAEA;
}

@media screen and (max-width: 768px) {
  .offer-details-modal .buttons-special {
    flex-direction: column;
    align-items: stretch;
  }
  
  .offer-details-modal .buttons-special .button {
    width: 100%;
  }
}

.error-desc {
  margin-top: 16px;
}
</style>

